import React, { useMemo } from 'react'
import EmptyStatus from '../empty-status'
import { Box, HStack } from '@chakra-ui/react'
import { useQueryState } from 'nuqs'
import { SimpleGrid, VStack } from '@chakra-ui/react'
import {
  PaginationItems,
  PaginationNextTrigger,
  PaginationPrevTrigger,
  PaginationRoot,
} from '@/components/ui/pagination'
import Preview from '../../_components/Preview'
import { IReservation } from '@/_service/types/reservations'
import ReservationCard from '@/entities/reservation/_components/Card'

export default function Reservations({
  isLoading,
  data,
}: {
  isLoading: boolean
  data:
    | {
        reservations: IReservation[]
        count: number | string
      }
    | undefined
}) {
  const [page, setPage] = useQueryState('page')
  const [id] = useQueryState('id')

  const orders = useMemo(() => {
    return data?.reservations?.map((order) => (
      <ReservationCard key={order.id} data={order} />
    ))
  }, [data])

  if (!isLoading && data?.count == 0) {
    return <EmptyStatus />
  } else
    return (
      <SimpleGrid w='full' columns={{ base: 1, md: 2 }} columnGap={7} px='4'>
        <VStack mb={'90px'} gap={4} alignItems='stretch'>
          {orders}

          {Number(data?.count) > 20 && (
            <PaginationRoot
              mt={4}
              pageSize={20}
              defaultPage={1}
              page={Number(page) || 1}
              count={Number(data?.count)}
              onPageChange={(e) => setPage(`${e.page}`)}
            >
              <HStack>
                <PaginationPrevTrigger />
                <PaginationItems />
                <PaginationNextTrigger />
              </HStack>
            </PaginationRoot>
          )}
        </VStack>

        <Box>{id && <Preview id={id} shipperId={''} />}</Box>
      </SimpleGrid>
    )
}
